import Echo from "laravel-echo";
import Pusher from "pusher-js";

export type ReverbEcho = Echo<"reverb">;

export function createEcho(
  reverbUrl: string,
  token: string,
  orgId: string | null,
): ReverbEcho {
  const url = new URL(reverbUrl);
  const port = url.port ? Number(url.port) : undefined;

  return new Echo({
    broadcaster: "reverb",
    Pusher,
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: url.hostname,
    wsPort: port ?? 80,
    wssPort: port ?? 443,
    forceTLS: url.protocol === "wss:",
    enabledTransports: ["ws", "wss"],
    authEndpoint: new URL(
      "/api/broadcasting/auth",
      import.meta.env.VITE_API_URL,
    ).toString(),
    auth: {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        ...(orgId ? { "X-Organisation-Id": orgId } : {}),
      },
    },
  });
}
